import React, { SVGProps } from 'react';

const UserIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.6345 9.84587C2.79334 10.1027 0.628782 12.5034 0.666501 15.3559V15.5005C0.666501 16.0528 1.11422 16.5005 1.6665 16.5005C2.21878 16.5005 2.6665 16.0528 2.6665 15.5005V15.3159C2.63644 13.5645 3.92894 12.0709 5.6665 11.8492C7.50066 11.6673 9.135 13.0068 9.31688 14.8409C9.32763 14.9494 9.33307 15.0583 9.33316 15.1672V15.5005C9.33316 16.0528 9.78088 16.5005 10.3332 16.5005C10.8854 16.5005 11.3332 16.0528 11.3332 15.5005V15.1672C11.3299 12.2183 8.93675 9.83049 5.98794 9.83374C5.87003 9.8339 5.75216 9.83793 5.6345 9.84587Z"
                fill="currentColor"
            />
            <path
                d="M6 8.5C8.20913 8.5 10 6.70913 10 4.5C10 2.29087 8.20913 0.5 6 0.5C3.79087 0.5 2 2.29087 2 4.5C2.00219 6.70822 3.79178 8.49778 6 8.5ZM6 2.5C7.10456 2.5 8 3.39544 8 4.5C8 5.60456 7.10456 6.5 6 6.5C4.89544 6.5 4 5.60456 4 4.5C4 3.39544 4.89544 2.5 6 2.5Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default UserIcon;
